import React, { useEffect, useState } from 'react'

import Map from './Map/Map'
import MainControl from './Controls'
import SettingsPanel from './Controls/settings-panel'
import UserProfile from './components/UserProfile'
import AccountStatusMessage from './components/AccountStatusMessage'
import { fetchMeContext } from './actions/adminActions'

import { useAuth } from 'react-oidc-context'

function App() {
  const auth = useAuth()
  const [userContext, setUserContext] = useState(null)
  const [userContextLoading, setUserContextLoading] = useState(false)
  const [userContextError, setUserContextError] = useState('')

  const handleLogout = () => {
    auth.removeUser()
    window.location.href = window.location.origin + '/'
  }

  // const signOutRedirect = () => {
  //   auth.removeUser()
  //   window.location.href = window.location.origin + '/'
  //   // const clientId = '2o6g6lnharrsg0eh2dfd1intv1'
  //   // const logoutUri = window.location.origin + '/' //'https://app-dev.drivepoints.com/'
  //   // const cognitoDomain = 'https://auth-dev.drivepoints.com'
  //   // window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
  //   //   logoutUri
  //   // )}`
  // }

  useEffect(() => {
    let isMounted = true
    const hydrate = async () => {
      if (!auth.isAuthenticated) {
        setUserContext(null)
        setUserContextLoading(false)
        setUserContextError('')
        return
      }

      setUserContextLoading(true)
      setUserContextError('')
      try {
        const data = await fetchMeContext(auth)
        if (isMounted) {
          setUserContext(data)
        }
      } catch (error) {
        if (isMounted) {
          setUserContextError(error.message || 'Failed to load account status')
        }
      } finally {
        if (isMounted) {
          setUserContextLoading(false)
        }
      }
    }
    hydrate()
    return () => {
      isMounted = false
    }
  }, [auth, auth.isAuthenticated])

  if (auth.isLoading) {
    return <div>Loading...</div>
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>
  }

  if (auth.isAuthenticated) {
    if (userContextLoading) {
      return <div>Loading...</div>
    }

    if (userContextError) {
      return <div>Encountering error... {userContextError}</div>
    }

    if (userContext?.userStatus !== 'APPROVED') {
      return (
        <div>
          <UserProfile userContext={userContext} />
          <AccountStatusMessage
            status={userContext?.userStatus}
            onSignOut={handleLogout}
          />
        </div>
      )
    }

    return (
      <>
        {/* <div>
          <pre> Hello: {auth.user?.profile.email} </pre>
          <pre> ID Token: {auth.user?.id_token} </pre>
          <pre> Access Token: {auth.user?.access_token} </pre>
          <pre> Refresh Token: {auth.user?.refresh_token} </pre>

          <button onClick={() => signOutRedirect()}>Sign out</button>
        </div> */}
        <div>
          <UserProfile userContext={userContext} />
          <Map />
          <MainControl userContext={userContext} />
          <SettingsPanel />
        </div>
      </>
    )
  }

  return (
    <>
      <UserProfile />
    </>
  )
}

export default App
